import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import iconCheck from "src/assets/images/iconCheck.svg";
import iconCheckActive from "src/assets/images/iconCheckActive.svg";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { setFulFillId, setRedeemDataAllInit, setRedeemImageList } from "../../store/reducers/redeemReduce";
import { useAppSelector } from "../../store/actions/action";

function redeemSelectImg() {
  const navigate = useNavigate();
  const images: Image[] = (useLocation() as any).state?.images;
  const fulfillId: string = (useLocation() as any).state?.fulfillId;
  const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
  const dispatch = useDispatch();
  const selectedImage = useAppSelector((state) => state.redeemReduce);

  function back() {
    dispatch(setRedeemDataAllInit());
    navigate(-1);
  }

  function next() {
    if (selectedImage.imageList.length == 0) {
      return alert("사진을 선택해주세요.");
    } else {
      const tempImageList = [...selectedImage.imageList];
      const sortedImageList = tempImageList.sort((a, b) => a.img_idx - b.img_idx);
      dispatch(setRedeemImageList({ imageList: sortedImageList }));

      dispatch(setFulFillId({ fulfillId: fulfillId }));
      return navigate("/redeem-request");
    }
  }

  function checkSelectedImage(imgUrl: string) {
    const temp = selectedImage.imageList.find((e) => e.img_url == imgUrl);
    return temp ? true : false;
  }

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => back()}>
            재이행 요청
          </Button>
        </div>
        <div className="btn-box">
          <Button variant="text" onClick={() => next()}>
            다음
          </Button>
        </div>
      </header>
      <Body type="detail">
        <div>
          <SelectImgList>
            {images.map((value, index) => {
              return (
                <li key={index}>
                  <input
                    type="checkbox"
                    id={"img-check" + index}
                    checked={checkSelectedImage(value.img_url)}
                    onChange={(e) => {
                      if (e.currentTarget.checked) {
                        dispatch(setRedeemImageList({ imageList: [...selectedImage.imageList, value] }));
                      } else {
                        const deleteImageList = selectedImage.imageList.filter((res) => res.img_url != value.img_url);
                        dispatch(setRedeemImageList({ imageList: deleteImageList }));
                      }
                    }}
                  />
                  <label htmlFor={"img-check" + index}>
                    <img src={imageServerIp + value.img_url} alt="더미이미지" />
                  </label>
                </li>
              );
            })}
          </SelectImgList>
        </div>
      </Body>
    </>
  );
}

const SelectImgList = styled.ul`
  padding-left: 15px;
  margin-top: 30px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center", "wrap")}
  > li {
    width: 50%;
    padding: 0 15px 15px 0;
    > input {
      overflow: hidden;
      display: inline-block;
      margin: 0;
      appearance: none;
      &:checked + label {
        &::before {
          background: url(${iconCheckActive}) no-repeat left center;
        }
        &::after {
          background: rgba(37, 47, 80, 0.5);
        }
      }
    }
    > label {
      position: relative;
      ${({ theme }) => theme.imgBox.coverBox()};
      &::before {
        content: "";
        display: block;
        z-index: 10;
        position: absolute;
        top: 8px;
        right: 8px;
        width: 24px;
        height: 24px;
        background: url(${iconCheck}) no-repeat left center;
      }
      &::after {
        content: "";
        display: block;
        z-index: 9;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
`;

export default redeemSelectImg;
